import { createSlice } from '@reduxjs/toolkit';

export const tenancySlice = createSlice({
    name: 'tenancy',
    initialState: {
        tenancyId: '',
        tenancyName: '',
        isHierarchyTenancy: false,
        tenancyLookup: {}, 
    },
    reducers: {
        setTenancyId: (state, action) => {
            state.tenancyId = action.payload;
        },
        setTenancyName: (state, action) => {
            state.tenancyName = action.payload;
        },
        setIsHierarchyTenancy: (state, action) => {
            state.isHierarchyTenancy = action.payload;
        },
        setTenancyLookup: (state, action) => {
            state.tenancyLookup = action.payload;
        },
    },
});

export const {
    setTenancyId,
    setTenancyName,
    setIsHierarchyTenancy,
    setTenancyLookup
} = tenancySlice.actions;

export default tenancySlice.reducer;